import { FormattedMessage } from 'dibs-react-intl';
import { BANNER_TYPES } from '../constants/checkoutConstants';

const { NEXT_STEPS } = BANNER_TYPES;

const banners = {
    [NEXT_STEPS]: {
        type: NEXT_STEPS,
        label: (
            <FormattedMessage
                id="checkout.CheckoutHeaderBanner.nextSteps"
                defaultMessage="Next Steps to Complete Your Offer"
            />
        ),
        content: (
            <FormattedMessage
                id="checkout.CheckoutHeaderBanner.nextStepsContent"
                defaultMessage="Fill out the information below so your order can be completed as soon as your offer is accepted."
            />
        ),
    },
} as const;
export type BannerTypes = keyof typeof banners;
export type Banner = (typeof banners)[BannerTypes];

export default banners;
